import { WHerToLogin } from "../../layouts/RootLayout/Navbar";

export const makeEntry = (
  labelKey,
  path,
  IconComponent,
  iconSize = 15,
  extraClass = "",
  t,
  navigate,
) => ({
  icon: (clr = "") => <IconComponent size={iconSize} className={`${clr}`} />,
  label: t(labelKey),
  labelKey,
  path,
  command: () => {
    WHerToLogin = path;
    navigate(path);
  },
});
